module.exports = __webpack_public_path__ + "static/images/resource-center.svg";